import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: (props) => props.iconProp ? 'transparent' : props.rsa ? '#DC1860' : '#1ef1c6',
        borderRadius: '15px',
        height: (props) => props.height ? '40px' : props.width ? '30px' : props.iconProp ? '40px' : '33px',
        color: (props) => props.iconProp ? '#1ef1c6' : props.rsa ? 'white' : '#000',
        border: (props) => props.iconProp ? '1px solid #1ef1c6' : props.rsa ? '' : '',
        textTransform: 'initial',
        fontFamily: 'LynkcoTypeMedium',
        '&:hover': {
            backgroundColor: (props) => props.iconProp ? 'transparent' : props.rsa ? '#893257' : '#088a70',
            color: (props) => props.iconProp ? '#339586' : '#000',
        },
        whiteSpace: 'nowrap',
        width: (props) => props.width ? '3vw' : props.iconProp ? '9vw' : props.widthProp ? '9vw' : '7vw',
        fontSize: '14px'
    }
}));

const SearchButton = (props) => {
    const classes = useStyles(props);
    const { handleSearch, placeholder, icon, iconProp = false, height, rsa, width, widthProp = false, type } = props;

    return (
        <Button onClick={handleSearch} className={classes.button} variant="contained" placeholder={placeholder} icon={icon} type={type}  >
            {placeholder}
            {icon}
        </Button>
    );
}

export default SearchButton;